import { useMutation } from '@tanstack/vue-query'
import { useI18n } from 'vue-i18n'
import { useToast } from '@ai/ui-components/toast'
import fetchApi from '@/utils/fetchApi'

interface ReportInteractionParams {
  callId: string
  comment?: string | null
}

export function useReportInteractionMutation() {
  const { t } = useI18n({ useScope: 'global' })
  const toast = useToast()

  return useMutation({
    mutationFn: ({ callId, comment }: ReportInteractionParams) =>
      fetchApi<{ success: boolean; uid: string }>(
        {
          endpoint: `/api/cold-monitoring/${callId}/report`,
          method: 'POST',
          body: { comment },
        },
        { suppressAlert: true },
      ),
    onSuccess: () => {
      toast.success(t('cold_monitoring.report_interaction.success'))
    },
    onError: () => {
      toast.error(t('cold_monitoring.report_interaction.error'))
    },
  })
}
